export default {
  csrf: '',
  IS_DEV: process.env.NODE_ENV === 'development',
  DEV_URL: 'http://localhost:5001',
  PROD_URL: 'http://127.0.0.1:5001'
  // PROD_URL: 'https://demo.kuaian.vip'
}